import {OperationStateTypesEnum} from 'presentation/constants';
import {useCallback, useState} from 'react';
import {useGetRefundTableUrlMutation} from '../pages/Request/mutations/useGetRefundTableUrlMutation';

export const useGetRefundTableUrl = () => {
	const [loadingUrlState, setIsLoadingUrlState] = useState(OperationStateTypesEnum.NONE);
	const {data: url, mutate} = useGetRefundTableUrlMutation({
		onMutate: () => {
			setIsLoadingUrlState(OperationStateTypesEnum.SUBMITTING);
		},
		onSuccess: data => {
			window.open(data);
			setIsLoadingUrlState(OperationStateTypesEnum.DONE);
		},
	});

	const getRefundTableUrl = useCallback(() => {
		if (url) {
			window.open(url);
			return;
		}
		mutate();
	}, [url]);

	const URL_IS_LOADING = loadingUrlState === OperationStateTypesEnum.SUBMITTING;

	return {
		URL_IS_LOADING,
		getRefundTableUrl,
	};
};
